import React, { useState } from 'react';
import Card from '../../components/ui/Card';
import Avatar from '../../components/ui/Avatar';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import { useToast } from '../../components/ui/Toast';
import { displayReports, employees, stores } from '../../data/mockData';
import { X, ZoomIn } from 'lucide-react';

const COLORS = ['#4A6CF7','#FF6B6B','#34C759','#FFBE0B','#FF9500','#8B5CF6'];

export default function PhotoReports() {
  const toast = useToast();
  const [selected, setSelected] = useState(null);

  const withPhoto = displayReports.filter(r => r.hasPhoto);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1A1A2E' }}>Фото-отчёты выкладок</h1>
        <p style={{ color: '#8E8E93', fontSize: 13, marginTop: 2 }}>Галерея фотографий • {withPhoto.length} фото</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16 }}>
        {withPhoto.map((r, i) => {
          const emp = employees.find(e => e.id === r.employeeId);
          const store = stores.find(s => s.id === r.storeId);
          const bg = COLORS[i % COLORS.length];
          return (
            <div key={r.id} style={{
              background: '#fff', borderRadius: 14, overflow: 'hidden',
              border: '1px solid #F0F0F0', boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
              cursor: 'pointer', transition: 'all 0.15s',
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)'; }}
              onClick={() => setSelected({ ...r, emp, store, bg })}>
              {/* Photo placeholder */}
              <div style={{
                height: 160, background: `linear-gradient(135deg, ${bg}22, ${bg}44)`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                position: 'relative', borderBottom: '1px solid #F0F0F0',
              }}>
                <span style={{ fontSize: 48 }}>📷</span>
                <div style={{
                  position: 'absolute', top: 8, right: 8, width: 32, height: 32,
                  borderRadius: '50%', background: 'rgba(255,255,255,0.9)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <ZoomIn size={14} color={bg} />
                </div>
                <div style={{ position: 'absolute', top: 8, left: 8 }}>
                  <Badge variant="success">📷 Фото</Badge>
                </div>
              </div>
              <div style={{ padding: '14px 16px' }}>
                <div style={{ fontWeight: 600, fontSize: 13, color: '#1A1A2E', marginBottom: 8 }}>{r.productName}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                  <Avatar name={emp?.name || '?'} size={22} />
                  <span style={{ fontSize: 12, color: '#6B7280' }}>{emp?.name}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#8E8E93' }}>
                  <span>{store?.name}</span>
                  <span>{new Date(r.date).toLocaleDateString('ru-RU')}</span>
                </div>
                <div style={{ marginTop: 10, display: 'flex', gap: 6 }}>
                  <button onClick={e => { e.stopPropagation(); toast('Выкладка подтверждена', 'success'); }} style={{ flex: 1, padding: '6px', borderRadius: 6, border: '1px solid #34C759', background: '#F0FFF4', cursor: 'pointer', fontSize: 11, fontWeight: 600, color: '#34C759', fontFamily: 'inherit' }}>
                    ✓ Принять
                  </button>
                  <button onClick={e => { e.stopPropagation(); toast('Запрос повторной выкладки отправлен', 'warning'); }} style={{ flex: 1, padding: '6px', borderRadius: 6, border: '1px solid #FEE2E2', background: '#FFF0F0', cursor: 'pointer', fontSize: 11, fontWeight: 600, color: '#FF3B30', fontFamily: 'inherit' }}>
                    ✗ Отклонить
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Lightbox */}
      {selected && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }} onClick={() => setSelected(null)}>
          <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', maxWidth: 600, width: '100%' }} onClick={e => e.stopPropagation()}>
            <div style={{ height: 320, background: `linear-gradient(135deg, ${selected.bg}22, ${selected.bg}66)`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontSize: 80 }}>📷</span>
            </div>
            <div style={{ padding: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <h3 style={{ fontWeight: 700, fontSize: 16 }}>{selected.productName}</h3>
                <button onClick={() => setSelected(null)} style={{ background: '#F3F4F6', border: 'none', borderRadius: 8, width: 32, height: 32, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <X size={16} />
                </button>
              </div>
              <div style={{ display: 'flex', gap: 16, marginTop: 12, fontSize: 13, color: '#6B7280' }}>
                <span>👤 {selected.emp?.name}</span>
                <span>🏪 {selected.store?.name}</span>
                <span>📅 {new Date(selected.date).toLocaleString('ru-RU')}</span>
              </div>
              <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
                <span style={{ fontSize: 13 }}>Требовалось: <strong>{selected.requiredQty}</strong> шт.</span>
                <span style={{ fontSize: 13 }}>Выложено: <strong style={{ color: selected.placedQty >= selected.requiredQty ? '#34C759' : '#FF9500' }}>{selected.placedQty}</strong> шт.</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
